$(function () {
    $(document).ready(function () {
        $('.contact-input').trigger('input');
        if (recaptchaEnabled) {
            grecaptcha.ready(function () {
                grecaptcha.execute(recaptchaSiteKey, {action: 'contact'}).then(function (token) {
                    var recaptchaResponse = document.getElementById('recaptchaResponse');
                    recaptchaResponse.value = token;
                });
            });
        }
    });

    $('.contact-input').on('input', function () {
        // 文字数を取得
        let cnt = $(this).val().length;
        //現在の文字数を表示
        let cnt_area;
        if ($(this).next('.cnt_area').length === 0) {
            cnt_area = $(this).next().next('.cnt_area');
        } else {
            cnt_area = $(this).next('.cnt_area');
        }
        cnt_area.find('.now-cnt').text(cnt);

        if(cnt <= 500){
            //1文字以上かつ500文字以内の場合はボタンを有効化＆黒字
            cnt_area.removeClass('red');
        }else{
            //0文字または500文字を超える場合はボタンを無効化＆赤字
            cnt_area.addClass('red');
        }
    });

    $('#contact_input_button').on('click' , function() {
        let $form = $('#contact_input_form');
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serializeArray(),
            dataType: 'json'
        }).done(function (data) {
            window.location.href = data.redirect;
        }).fail(function (data) {
            if (recaptchaEnabled) {
                grecaptcha.execute(recaptchaSiteKey, {action: 'contact'}).then(function (token) {
                    var recaptchaResponse = document.getElementById('recaptchaResponse');
                    recaptchaResponse.value = token;
                });
            }
        });
    });
});
